import { render, staticRenderFns } from "./CreateEditOrder.vue?vue&type=template&id=8e2ca71e&scoped=true"
import script from "./CreateEditOrder.vue?vue&type=script&lang=js"
export * from "./CreateEditOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2ca71e",
  null
  
)

export default component.exports